<template>
    <!-- Dashboard card Summary -->
    <v-row class="mb-4" align="stretch">
        <v-col v-for="(stat, index) in stats" :key="index" cols="12" sm="6" md="3">
            <v-card :color="stat.color" dark elevation="2"
                class="stat-card d-flex flex-column align-center justify-center" hover>
                <div class="text-subtitle-1 text-center text--secondary">{{ stat.label }}</div>
                <div class="text-h4 font-weight-bold mt-2 text--secondary">{{ stat.value }}</div>
            </v-card>
        </v-col>
    </v-row>
</template>

<script>
export default {
    name: 'DistriDashTiles',
    data() {
        return {
            stats: [
                { label: 'Partners', value: 0, color: 'purple darken-1' },
                { label: 'Customers', value: 0, color: 'blue-grey darken-1' },
                { label: 'Opportunities Won', value: 0, color: 'green darken-1' },
                { label: 'Opportunities in Pipeline', value: 0, color: 'amber darken-2' },
                { label: 'Opportunities Lost', value: 0, color: 'red darken-1' },
            ]
        };
    },
    mounted() {
        this.fetchDashboardData();
    },
    methods: {
        async fetchDashboardData() {

            const distributorGUID = localStorage.getItem('distributorGuid') || '';
            try {
                const response = await fetch(`${process.env.VUE_APP_VORTEX_PORTAL_WS}/distributor/dash-stats`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({ distributorGUID })
                });

                if (!response.ok) {
                    return;
                }

                const data = await response.json();

                const dashboard = data.distributorDashboard;
                if (!dashboard) {
                    console.warn('Dashboard data missing');
                    return;
                }
                this.stats[0].value = dashboard.partners?.length || 0;

                this.stats[1].value = dashboard.botCount || 0;

                this.stats[2].value = dashboard.oppsStats?.['Evaluation'] || 0;

                this.stats[3].value = (dashboard.oppsStats?.Commit || 0) + (dashboard.oppsStats?.Evaluation || 0) + (dashboard.oppsStats?.Proposal || 0);


                this.stats[4].value = dashboard.oppsStats?.['Closed - Won'] || 0;
            } catch (error) {
                console.error('Error fetching dashboard data:', error);
            }
        }
    }
};
</script>

<style scoped>
.stat-card {
    width: 100%;
    height: 140px;
    border-radius: 12px;
    padding: 16px;
}

.text-center {
    text-align: center;
}
</style>
